<script lang="ts" setup>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';
import { formatNumber } from '@/home/utils/format';
import Platform from '@/common/components/platform-avatar/index.vue'

const { $fetch } = useFetch();

const { data } = useAsyncData("home:repo",
  () => $fetch('warehouse/home_warehouse_list',
    {
      method: 'post', data: { pageNum: 1, pageSize: 6 },
    },
  ),
)
</script>

<template>
  <div class="rounded-8 bg-white">
    <div class="h-78 content-center px-24">
      <h3 class="text-16 text-#1f1f1f font-normal">热门仓库</h3>
    </div>
    <ul v-if="data?.records">
      <li v-for="item in data.records" :key="item.name" class="px-24 hover:bg-[#3d7cfa] hover:bg-opacity-3">
        <a class="page-home-recommend-repository block" :href="item.jump" target="_blank">
          <div class="border-t-1 border-hex-fafafa border-solid py-20">
            <h3 class="flex items-center">
              <span v-if="item.isSelected" class="mr-8 mt-1 inline-block h-22 rounded-4 bg-[#feefde] px-6 text-12 text-[#FC8B06] font-400 leading-22">
                {{ $t('home.home.template3.prime') }}
              </span>
              <span class="truncate text-16 color-hex-292929 font-500 leading-24" :title="`${item.belongName ? `${item.belongName}/` : ''}${item.name}`">
                {{ item.belongName ? `${item.belongName}/` : '' }}{{ item.name }}
              </span>
              <Platform class="ml-4 shrink-0" :platform="item.platform" icon-class="size-16" tooltip />
            </h3>

            <p class="line-clamp-1 mt-4 break-anywhere text-14px color-hex-575757 font-400 leading-22">
              {{ item.description ? item.description : $t('home.home.recommend.repository.empty') }}
            </p>

            <div class="mt-8 flex-y-center justify-between">
              <div class="text-12 text-hex-adadad font-400 leading-20">
                <span>{{ $t('home.home.template3.type3') }}</span>
              </div>
              <div class="flex-y-center gap-24">
                <div class="flex-y-center gap-4 text-12 color-hex-575757 font-400">
                  <div class="i-icons:star size-16"></div>
                  <div class="h-16">{{ formatNumber(item.starCount) }}</div>
                </div>
                <div class="flex-y-center gap-4 text-12 color-hex-575757 font-400">
                  <div class="i-icons:fork size-16"></div>
                  <div class="h-16">{{ formatNumber(item.forkCount) }}</div>
                </div>
                <div v-if="item.license" class="flex-y-center gap-4 text-12 color-hex-575757 font-400">
                  <div class="i-icons:license size-16"></div>
                  <div class="h-16">{{ item.license }}</div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
</style>
